import { Injectable } from '@angular/core';

@Injectable()
export class SecurityService {
    private token: string | null = null;

    public getToken() {
        if (!this.token || this.token == '') {
            this.token = localStorage.getItem('token');
        }
        return this.token;
    }

    public setToken(token: string) {
        this.token = token;
        localStorage.setItem('token', token);
    }
}
